import React from 'react'
import PropTypes from 'prop-types'
import { colors, Text } from 'ic-snacks'
import { FormattedMessage } from 'react-intl'
import styled from '@emotion/styled'

import { type MetricData } from 'legacy/components/DataViz/dataViz.types'
import FlexColumn from 'legacy/components/FlexColumn'
import Delta from 'legacy/components/DataViz/Metrics/Delta'
import MetricValue from 'legacy/components/DataViz/Metrics/MetricValue'

export const MetricContainer = styled(FlexColumn)`
  justify-content: flex-start;
  height: auto;
  min-width: 300px;
  padding: 20px;
  border-right: 1px solid ${colors.GRAY_88};
  border-bottom: 1px solid ${colors.GRAY_88};
`

interface Props extends MetricData {}

class Metric extends React.PureComponent<Props> {
  static propTypes = {
    this_period: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    last_period: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    data_type: PropTypes.oneOf(['seconds', 'currency', 'number', 'percent']),
    desired_direction: PropTypes.oneOf(['positive', 'negative', 'neutral']),
  }

  static defaultProps = {
    data_type: 'count',
  }

  render() {
    const { last_period, data_type, this_period, desired_direction, title_key, note } = this.props

    const [parsedThisPeriod, parsedLastPeriod] = [this_period, last_period].map(n =>
      typeof n === 'string' ? parseFloat(n) : n
    )

    return (
      <MetricContainer>
        <Text
          variant="T.12"
          fontWeight="semiBold"
          style={{ color: colors.GRAY_46, textTransform: 'uppercase' }}
        >
          <FormattedMessage id={title_key} />
        </Text>
        <Text variant="T.46">
          <MetricValue value={parsedThisPeriod} dataType={data_type} />
        </Text>
        {parsedThisPeriod !== null && (
          <Text variant="T.16">
            <Delta
              value={parsedThisPeriod}
              previousValue={parsedLastPeriod}
              desiredDirection={desired_direction}
            />
          </Text>
        )}
        {note && (
          <Text variant="T.12" style={{ color: colors.GRAY_46 }}>
            <FormattedMessage id={note} />
          </Text>
        )}
      </MetricContainer>
    )
  }
}

export default Metric
